import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { REDUCER_NAME, createCustomFeature } from 'src/reducers/desk/customFeature';
import { CUSTOM_FEATURE_FORM } from 'src/constants/FormNames';
import { setItem, getItem, getItemErrors } from 'src/reducers/common/itemReducer';

import CustomFeatureEditing from './CustomFeatureEditing';

let CustomFeatureEditingForm = reduxForm({
  form: CUSTOM_FEATURE_FORM,
})(CustomFeatureEditing);

const mapStateToProps = (state) => ({
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: {
    ...getItem(REDUCER_NAME, state),
  },
});

const mapDispatchToProps = (dispatch) => ({
  onSubmit: (data) => {
    dispatch(createCustomFeature(data));
  },
});

CustomFeatureEditingForm = connect(mapStateToProps, mapDispatchToProps)(CustomFeatureEditingForm);

const CustomFeatureForm = ({ dispatch, values, params }) => {
  dispatch(
    setItem(
      REDUCER_NAME,
      values
        ? values
        : {
            condition: '',
            featureType: '',
            option: '',
            value: '',
            clientId: params.client_id
          }
    )
  );

  return <CustomFeatureEditingForm params={params} isNewForm/>;
};

export default connect()(CustomFeatureForm);
